// extracted by mini-css-extract-plugin
export default {"banner":"X6","mobileImage":"Y6","deskimg":"Z6","desktopImage":"a7","wrapper":"b7","text":"c7","text_wrapper":"e7","breadContain":"f7","systemWrapper":"g7","system":"h7"};
    if(module.hot) {
      // 1737143664964
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  